import { Paper, Stack, Typography } from "@mui/material";
import { type FC, type ReactNode } from "react";

export const FollowUpBodySection: FC<{
  title: string;
  subtitle: string;
  children: ReactNode;
  slots?: {
    titleRight?: ReactNode;
  };
}> = ({ title, subtitle, children, slots }) => {
  return (
    <Paper elevation={5} sx={{ p: 4 }}>
      <Stack direction="column" spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{title}</Typography>
          {slots?.titleRight}
        </Stack>
        <Typography variant="body1">{subtitle}</Typography>
        {children}
      </Stack>
    </Paper>
  );
};
